import { MTagColor } from '@mercadona/components-musi/tag';

export class EvaluationListItem {
  id!: number;
  title!: string;
  coordinatorName!: string;
  deliveredAt!: string;
  chips!: EvaluationListItemChip[];
  year!: number;
}

export class EvaluationListItemChip {
  label!: string;
  type!: MTagColor;
}

export class EvaluationDetail {
  id!: number;
  title!: string;
  coordinatorName!: string;
  deliveredAt!: string;
  chips!: EvaluationListItemChip[];
  sections!: EvaluationSection[];
  remunerationChanges!: EvaluationRemunerationChanges | null;
}

export class EvaluationSection {
  title!: string | null;
  chip!: EvaluationListItemChip | null;
  html!: string | null;
  cards!: EvaluationSectionCard[] | null;
}

export class EvaluationSectionCard {
  chip!: EvaluationListItemChip | null;
  title!: string;
  imageUrl!: string | null;
  tooltip!: string | null;
}

export class EvaluationRemunerationChanges {
  headline!: string;
  headlineColor!: string;
  periods!: EvaluationRemunerationChangesPeriod[];
}

export class EvaluationRemunerationChangesPeriod {
  year!: number;
  yearType!: MTagColor;
  fields!: EvaluationRemunerationChangesPeriodField[];
}

export class EvaluationRemunerationChangesPeriodField {
  label!: string;
  values!: string[];
}
